import { BooleanInput, ControlGroup, FormActions, GenericReactForm, PasswordInput, StringInput, SubmitButton } from 'client/js/util/form_utils';
import { Link } from 'react-router-dom';
import SixDigitCodeInput from 'client/js/components/six_digit_code_input';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import { matomoPush } from 'client/js/util/matomo';

const MATOMO_REGISTRATION_GOAL_ID = 1;

const adjectives = [
  'awesome', 'cool', 'great', 'fantastic', 'amazing', 'wonderful', 'marvelous', 'incredible',
  'fabulous', 'astonishing', 'unbelievable', 'remarkable', 'phenomenal', 'magnificent',
  'brilliant', 'stunning', 'spectacular', 'splendid', 'outstanding', 'impressive',
  'excellent', 'superb', 'terrific', 'tremendous', 'inventive', 'ingenious', 'creative',
  'clever', 'smart', 'intelligent', 'bright', 'brainy', 'genius', 'gifted', 'talented',
  'skilled', 'capable', 'competent', 'proficient', 'adept', 'expert', 'masterful',
  'masterly', 'artistic', 'virtuoso', 'dexterous', 'adroit', 'deft', 'nimble', 'handy',
  'slick', 'sharp', 'quick', 'agile', 'vigorous', 'dynamic', 'energetic', 'sporty',
  'strong', 'powerful', 'muscular', 'robust', 'sturdy', 'rugged', 'stalwart'
];

const nouns = [
  'tesla', 'einstein', 'curie', 'newton', 'darwin', 'galilei', 'hawking', 'bohr',
  'hubble', 'kepler', 'copernicus', 'faraday', 'heisenberg', 'planck', 'sagan',
  'herschel', 'ampere', 'bell', 'babbage', 'boole', 'fermi', 'franklin', 'hertz'
];

class SignupUsernameInput extends React.Component {
  state = { checking: false, available: null, errors: null }

  change = (e) => {
    const value = e.target.value.toLowerCase();
    this.setState({ available: null, errors: null });
    this.context.formDispatch('value_changed', e, { name: 'username', value: value });
  }

  checkUsername = (username = this.context.formData.username) => {
    if (!username)
      return;

    this.setState({ checking: true });

    $.ajax(`/register/check-username?username=${encodeURIComponent(username)}`)
      .done((data) => {
        this.setState({
          checking: false,
          available: data.available,
          errors: data.errors
        });
      })
      .fail(() => {
        this.setState({
          checking: false,
          available: false,
          errors: 'Der Benutzername konnte nicht geprüft werden'
        });
      });
  }

  generateProjectName = (e) => {
    e.preventDefault();

    const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    const number = 100 + Math.floor(Math.random() * 899);
    const username = `${adjective}-${noun}-${number}`;

    this.context.formDispatch('value_changed', e, { name: 'username', value: username });
    this.setState({ available: null, errors: null }, () => this.checkUsername(username));
  }

  render() {
    const name = 'signup_username';
    const serverErrors = this.context.serverErrors.username;
    const value = this.context.formData.username || '';
    const availabilityChecked = this.state.available !== null;
    const hasErrors = (serverErrors && serverErrors.length) || this.state.available === false;
    const inputClasses = [
      'form-control',
      'text',
      'required',
      availabilityChecked && (this.state.available ? 'is-valid' : 'is-invalid')
    ].filter(Boolean).join(' ');
    const groupClasses = [
      'signup-username-field',
      this.state.checking && 'loading',
      availabilityChecked && (this.state.available ? 'username-available' : 'username-unavailable')
    ].filter(Boolean).join(' ');

    return (
      <div className={groupClasses}>
        <ControlGroup
          type="text"
          name={name}
          labelFor={name}
          required
          errors={serverErrors}
          label="Benutzername"
          hint={<span>Der Benutzername sollte wie ein öffentlicher Projektname behandelt werden (z.B. baeckerei-mueller). Er kann später nicht mehr geändert werden und ist - bei Webhosting-Paketen - Teil der Verzeichnisstruktur und für andere Kunden auf dem gleichen Server sichtbar. Du kannst auch einen Namen <button type="button" className="btn btn-link p-0 align-baseline" onClick={this.generateProjectName}>generieren</button>.</span>}>
          <input
            aria-required
            className={inputClasses}
            id={name}
            maxLength="32"
            name="signup[username]"
            onBlur={() => this.checkUsername()}
            onChange={this.change}
            pattern="^[a-zA-Z]+[a-zA-Z\-0-9]+[a-zA-Z0-9]+$"
            readOnly={this.state.checking}
            required
            type="text"
            value={value}
          />
          {this.state.checking && <small className="form-text text-muted">Benutzername wird geprüft...</small>}
          {availabilityChecked && !hasErrors && <div className="valid-feedback d-block">Benutzername verfügbar</div>}
          {availabilityChecked && this.state.available === false && <div className="invalid-feedback d-block">{this.state.errors}</div>}
        </ControlGroup>
      </div>
    );
  }
}

SignupUsernameInput.contextTypes = {
  formData: PropTypes.object,
  formDispatch: PropTypes.func,
  serverErrors: PropTypes.object
};

class SignupCaptcha extends React.Component {
  state = { mounted: false }

  componentDidMount() {
    this.setState({ mounted: true });
  }

  change = (value) => {
    this.context.formDispatch('value_changed', null, { name: 'recaptcha_response', value: value });
  }

  render() {
    if (!this.props.show)
      return null;

    return (
      <ControlGroup name="captcha" errors={this.context.serverErrors.captcha}>
        <div className="signup-captcha-text">
          Bitte zeige uns, dass Du ein Mensch bist:
        </div>
        {this.state.mounted && <ReCAPTCHA sitekey={this.props.recaptcha_site_key} onChange={this.change} />}
      </ControlGroup>
    );
  }
}

SignupCaptcha.contextTypes = {
  formDispatch: PropTypes.func,
  serverErrors: PropTypes.object
};

class Signup extends React.Component {
  state = { completed: false, promotion: false, email: null, activationCode: '', activationLoading: false, activationError: null, activated: false }

  dispatch = (action, _originalEvent, data) => {
    if (action == 'form:validation_errors' && data.errors && data.errors.captcha)
      this.setState({ showCaptcha: true });

    if (action != 'form:success')
      return;

    if (data.object.return_url) {
      window.location.href = data.object.return_url;
      return;
    }

    this.setState({
      completed: true,
      promotion: data.object.promotion,
      email: data.object.email
    });
  }

  changeActivationCode = (code) => {
    this.setState({ activationCode: code, activationError: null });
  }

  verifyActivationCode = async (code = this.state.activationCode) => {
    if (code.length !== 6 || this.state.activationLoading)
      return;

    this.setState({ activationLoading: true, activationError: null });

    try {
      const response = await fetch('/register/activate-code', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ code: code })
      });

      const data = await response.json();

      if (response.ok && data.status === 'ok') {
        matomoPush(['trackGoal', MATOMO_REGISTRATION_GOAL_ID]);
        matomoPush(['trackEvent', 'sign_up', 'sign_up']);
        this.setState({ activated: true, activationLoading: false });
        return;
      }

      this.setState({
        activationError: data.message || 'Der Code konnte nicht geprüft werden.',
        activationLoading: false,
        activationCode: ''
      });
    } catch {
      this.setState({
        activationError: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
        activationLoading: false
      });
    }
  }

  renderSuccess() {
    if (this.state.activated) {
      return (
        <div className="login-form-panel login-form-panel-signup">
          <h1 className="login-title">E-Mail bestätigt</h1>
          <div className="alert alert-success">Dein Account ist jetzt aktiviert.</div>
          {this.props.cart_has_items && <a href="/checkout" className="btn btn-lg btn-success btn-block mb-2">Bestellung fortsetzen &rarr;</a>}
          <a href="/usercp" className="btn btn-lg btn-primary btn-block">zur Verwaltung &rarr;</a>
        </div>
      );
    }

    if (this.state.promotion) {
      return (
        <div className="login-form-panel login-form-panel-signup">
          <h1 className="login-title">E-Mail bestätigen</h1>
          <div className="alert alert-success">Vielen Dank für Deine Anmeldung!</div>
          {this.renderActivationCodeForm()}
        </div>
      );
    }

    return (
      <div className="login-form-panel login-form-panel-signup">
        <h1 className="login-title">E-Mail bestätigen</h1>
        <div className="alert alert-success">
          Vielen Dank für Deine Anmeldung!
        </div>
        {this.renderActivationCodeForm()}
      </div>
    );
  }

  renderActivationCodeForm() {
    const canVerify = this.state.activationCode.length === 6 && !this.state.activationLoading;

    return (
      <form onSubmit={(e) => this.verifyActivationCode(e.preventDefault() || this.state.activationCode)}>
        <p>Wir haben einen 6-stelligen Code an <strong>{this.state.email}</strong> gesendet. Bitte gib ihn hier ein, um Deinen Account zu aktivieren.</p>

        {this.state.activationError && (
          <div className="alert alert-danger">{this.state.activationError}</div>
        )}

        <SixDigitCodeInput
          value={this.state.activationCode}
          onChange={this.changeActivationCode}
          onComplete={this.verifyActivationCode}
          disabled={this.state.activationLoading}
          className="d-flex justify-content-center mb-3"
        />

        <p className="text-center text-muted small">Du kannst alternativ weiterhin den Aktivierungslink aus der E-Mail verwenden.</p>

        <FormActions>
          <button className="btn btn-lg btn-primary" disabled={!canVerify}>
            <i className={this.state.activationLoading ? 'fa fa-spinner fa-spin' : 'fa fa-check'}></i>
            {' '}Account aktivieren
          </button>
        </FormActions>
      </form>
    );
  }

  render() {
    if (this.state.completed)
      return this.renderSuccess();

    return (
      <div className="login-form-panel login-form-panel-signup">
        <h1 className="login-title">Registrierung</h1>

        {this.props.logged_in && (
          <div className="alert alert-warning">
            <h4 className="alert-heading">Bereits angemeldet!</h4>
            <p className="mb-0">Du bist bereits eingeloggt. Deinen Account kannst Du in der <a href="/usercp">Verwaltung</a> verwalten. Möchtest Du wirklich einen neuen Account erstellen?</p>
          </div>
        )}

        {!this.props.promotion && <p className="lead">Du hast bereits einen Account? <Link to="/login">Login</Link></p>}

        <GenericReactForm namespace="signup" url={this.props.url} dispatch={this.dispatch}>
          <SignupUsernameInput />
          <StringInput required name="email" type="email" autoComplete="email" label="E-Mail" placeholder={this.props.email_placeholder} hint="Deine E-Mail-Adresse wird mit einer Bestätigungs-E-Mail überprüft. Bitte verwende keine Wegwerf-Adresse (Trashmail)!" />
          <PasswordInput required name="password" label="Passwort" />
          <BooleanInput required name="tos_accepted" label={<span>Ich habe die <a href="/AGB.pdf" target="_blank">allgemeinen Geschäftsbedingungen <i className="fa fa-external-link"></i></a> gelesen, verstanden und akzeptiere sie. <br /><strong>Ich werde keine Phishing-Seiten, auch nicht zu Test- oder Demonstrationszwecken, auf meinen Webspace laden. Ich verstehe, dass dies eine sofortige Sperre begründet.</strong></span>} />
          <BooleanInput name="subscribe" label="Ich möchte den Newsletter und Angebote erhalten" />
          <SignupCaptcha show={this.props.show_captcha || this.state.showCaptcha} recaptcha_site_key={this.props.recaptcha_site_key} />

          <FormActions>
            <SubmitButton text="kostenlos anmelden" />
          </FormActions>
        </GenericReactForm>
      </div>
    );
  }
}

Signup.defaultProps = {
  cart_has_items: false,
  logged_in: false,
  promotion: false,
  show_captcha: false
};

Signup.propTypes = {
  cart_has_items: PropTypes.bool,
  email_placeholder: PropTypes.string,
  logged_in: PropTypes.bool,
  promotion: PropTypes.bool,
  recaptcha_site_key: PropTypes.string,
  show_captcha: PropTypes.bool,
  url: PropTypes.string.isRequired
};

export default Signup;
